<ng-container *ngIf="questions.length > 0; else defaultQuestionsBlock">
  <ng-container *ngFor="let item of questions; index as i">
    <div class="c-form-field c-form-field--d" [class.is-required]="item.required">
      <span class="c-form-field__label" style="word-break: break-all">{{ item.question.question }}</span>
      <ng-container
        *ngTemplateOutlet="
          typeTmpl;
          context: { question: item.question, control: form.controls[i].controls.answer, name: i, questionId: item.question_id }
        "
      >
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template let-question="question" let-control="control" let-name="name" let-questionId="questionId" #typeTmpl>
  <div [ngSwitch]="question.type">
    <div *ngSwitchCase="'select'">
      <p500-ui-select-field
        [ngModel]="control.value[0] ? control.value : null"
        (ngModelChange)="formChange($event, control)"
        [data]="question.answers"
      ></p500-ui-select-field>
    </div>
    <div *ngSwitchCase="'radio'">
      <ng-container *ngFor="let item of question.answers">
        <div class="mb-5">
          <p500-ui-radio-field
            [ngModel]="control.value == item ? item : null"
            (ngModelChange)="formChange($event, control)"
            [value]="item"
            [label]="item"
            [name]="name"
          >
          </p500-ui-radio-field>
        </div>
      </ng-container>
    </div>
    <div *ngSwitchCase="'text'">
      <p500-ui-text-field [ngModel]="control.value" (ngModelChange)="formChange($event, control)"></p500-ui-text-field>
    </div>
    <div *ngSwitchCase="'checkbox'">
      <p500-ui-group-checkbox
        itemClass="mb-5"
        [ngModel]="makeCheckboxValues(control.value)"
        [checkboxes]="makeCheckboxData(question.answers)"
        (ngModelChange)="checkboxChange($event, control)"
      >
      </p500-ui-group-checkbox>
    </div>
    <div *ngSwitchCase="'countryRegion'">
      <gtd-country-region
        [data]="countries || []"
        [ngModel]="selectedCountryRegions.get(questionId)"
        [multiple]="true"
        (ngModelChange)="countryRegionChange($event, control, questionId)"
      >
      </gtd-country-region>
    </div>
  </div>
</ng-template>

<ng-template #defaultQuestionsBlock>
  <div class="c-modal__message">
    {{ defaultQuestion }}
  </div>
</ng-template>
